var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"background-color":"light-green lighten-4","color":_vm.color,"value":_vm.value,"height":_vm.thin ? 4 : 8}})}
var staticRenderFns = []

export { render, staticRenderFns }